var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReOrderUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#E5F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4868 14.3618C18.9321 13.8794 19.7114 13.8794 20.1567 14.3618L27.2817 21.4868C27.7642 21.9321 27.7642 22.7114 27.2817 23.1567C26.8364 23.6392 26.0571 23.6392 25.6118 23.1567L19.3403 16.8853L13.0317 23.1567C12.5864 23.6392 11.8071 23.6392 11.3618 23.1567C10.8794 22.7114 10.8794 21.9321 11.3618 21.4868L18.4868 14.3618Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOrderUp);
export default __webpack_public_path__ + "static/media/re_order_up.62bc434963e8fae9b49b1b8a3f0c9ddc.svg";
export { ForwardRef as ReactComponent };